import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { share, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdaptiveService {
  public DESKTOP_MIN_WIDTH = 992;
  public TABLET_MAX_WIDTH = 991;
  public TABLET_MIN_WIDTH = 768;
  public MOBILE_MAX_WIDTH = 767;
  public MOBILE_MIN_WIDTH = 576;

  private resize$: Observable<Window>;

  public isDesktop() {
    return window.innerWidth > this.TABLET_MAX_WIDTH;
  }

  public isMobile() {
    return window.innerWidth < this.TABLET_MIN_WIDTH;
  }

  public isTablet() {
    return (
      window.innerWidth > this.MOBILE_MAX_WIDTH &&
      window.innerWidth < this.DESKTOP_MIN_WIDTH
    );
  }

  public isExtraSmall() {
    return window.innerWidth < this.MOBILE_MIN_WIDTH;
  }

  public getResizeEvent() {
    if (!this.resize$) {
      this.resize$ = fromEvent(window, 'resize').pipe(
        map(e => e.currentTarget as Window),
        share()
      );
    }

    return this.resize$;
  }
}
